import { transferDiff } from "./transfer.utils";
import DiffAmountText from "./DiffAmountText";

interface TransferDiffTextProps {
  /** ยอดที่ต้องโอน. */
  required: number | null | undefined;
  /** ยอดโอนจริง — null/undefined = ยังไม่มีการส่งสลิป. */
  transfer: number | null | undefined;
}

/**
 * "ผลต่าง" for a row that carries the two operands — the arithmetic companion to
 * TransferAmountText, which prints `{ต้องโอน}/{โอน}` side by side and signals only whether
 * they match.
 *
 * The subtraction (and its "no submission yet" case) lives in `transferDiff`; how the result
 * is painted lives in DiffAmountText, which the branch-day summary shares with a figure the
 * server computed.
 */
export default function TransferDiffText({
  required,
  transfer,
}: TransferDiffTextProps) {
  return <DiffAmountText diff={transferDiff(required, transfer)} />;
}
